module.exports = __webpack_public_path__ + "static/media/logo-wit.fee35136.png";